import { Injectable } from '@angular/core';

import {
  faPaperPlane,
  faBookmark,
  faInfoCircle,
  faCheck,
  faExclamationTriangle,
  faTimesCircle,
  faChevronRight,
  faChevronDown,
  faChevronUp,
  faChevronLeft,
  faTrashAlt,
  faBackspace,
  faPlusCircle,
  faRedo,
  faGripLinesVertical,
  faMinusSquare,
  faPlusSquare,
  faCloudUpload,
  faPlay,
  faLock,
  faLockOpen,
  faExclamationCircle,
  faPlus,
  faArrowUp,
  faArrowDown,
  faUpload,
  faTimes,
  faArrowRight,
  faLongArrowRight,
  faPlayCircle,
  faClone,
  faThumbsUp,
  faThumbsDown,
  faFileAlt,
  // The Learner and Counselor Resources tab strip asks for these four by name
  // and `fal` is the default prefix. Three of them were never registered, so
  // the tab strip threw during change detection and took the page with it.
  faUser,
  faUsers,
  faUniversalAccess,
  faLink
} from '@fortawesome/pro-light-svg-icons';
import {
  faLink as farLink,
  faClone as farClone,
  faEnvelope as farEnvelope,
  faArrowToBottom as farArrowToBottom,
  faArrowLeft as farArrowLeft,
  faBullseyeArrow as farBullseyeArrow,
  faSync as farSync,
  faExpandAlt as farExpandAlt,
  faExpand as farExpand,
  faCompress as farCompress,
  faCompressAlt as farCompressAlt,
  faCog as farCog,
  faHomeAlt as farHomeAlt,
  faCalendar as farCalendar,
  faSignOut as farSignOut,
  faLock as farLock,
  faUnlock as farUnlock,
  faRedo as farRedo,
  faArrowRight as farArrowRight,
  faCopy as farCopy,
  faUser as farUser,
  faGraduationCap as farGraduationCap,
  faSackDollar as farSackDollar,
  faClock as farClock,
  faSeedling as farSeedling,
  faCheckCircle as farCheckCircle,
  faTimesCircle as farTimesCircle,
  faSearch as farSearch,
  faCheck as farCheck,
  faSignInAlt as farSignInAlt,
  faSignOutAlt as farSignOutAlt,
  faKey as farKey,
  faFolder as farFolder,
  faPlus as farPlus,
  faTrashAlt as farTrashAlt,
  faCommentAlt as farCommentAlt,
  // PWS 4.3.4. The alerts bell and the four notification row kinds. A missing
  // definition does not degrade, it throws inside change detection, so every
  // icon the drawer can ask for has to be here.
  faBell as farBell,
  faComment as farComment,
  faBuilding as farBuilding,
  faChartLine as farChartLine
} from '@fortawesome/pro-regular-svg-icons';
import {
  faBookmark as fasBookmark,
  faSmile as fasSmile,
  faMeh as fasMeh,
  faFrown as fasFrown,
  faInfoCircle as fasInfoCircle,
  faCheckCircle as fasCheckCircle,
  faTimesCircle as fasTimesCircle,
  faCircle as fasCircle,
  faCommentAltLines as fasCommentAltLines,
  faChevronRight as fasChevronRight,
  faChevronLeft as fasChevronLeft,
  faArrowRight as fasArrowRight,
  faArrowLeft as fasArrowLeft,
  faLock as fasLock,
  faLockOpen as fasLockOpen,
  faPencil as fasPencil,
  faTrash as fasTrash,
  faBars as fasBars,
  faUser as fasUser,
  faEye as fasEye,
  faEyeSlash as fasEyeSlash,
  faMinusCircle as fasMinusCircle,
  faExclamationCircle as fasExclamationCircle,
  faCog as fasCog,
  faGraduationCap as fasGraduationCap,
  faQuestion as fasQuestion,
  faBriefcase as fasBriefcase,
  faPlusCircle as fasPlusCircle,
  faPaperPlane as fasPaperPlane,
  faCommentAltDots as fasCommentAltDots,
  faFolder as fasFolder,
  faClone as fasClone,
  faThumbsUp as fasThumbsUp,
  faThumbsDown as fasThumbsDown,
  faUpload as fasUpload,
  faShieldAlt as fasShieldAlt
} from '@fortawesome/pro-solid-svg-icons';
import { FaIconLibrary, FaConfig } from '@fortawesome/angular-fontawesome';

@Injectable({
  providedIn: 'root'
})
export class FontAwesomeIconRegistryService {
  constructor(
    private library: FaIconLibrary,
    private faConfig: FaConfig
  ) {}

  init() {
    // config
    this.faConfig.defaultPrefix = 'fal';

    // light icons
    this.library.addIcons(
      faPaperPlane,
      faBookmark,
      faInfoCircle,
      faCheck,
      faExclamationTriangle,
      faTimesCircle,
      faChevronUp,
      faChevronRight,
      faChevronDown,
      faChevronLeft,
      faTrashAlt,
      faBackspace,
      faPlusCircle,
      faRedo,
      faGripLinesVertical,
      faMinusSquare,
      faPlusSquare,
      faCloudUpload,
      faPlay,
      faLock,
      faLockOpen,
      faExclamationCircle,
      faArrowUp,
      faArrowDown,
      faArrowRight,
      faUpload,
      faTimes,
      faPlus,
      faLongArrowRight,
      faPlayCircle,
      faClone,
      faThumbsUp,
      faThumbsDown,
      faFileAlt,
      faUser,
      faUsers,
      faUniversalAccess,
      faLink
    );

    // regular
    this.library.addIcons(
      farLink,
      farClone,
      farArrowToBottom,
      farArrowLeft,
      farBullseyeArrow,
      farSync,
      farExpand,
      farExpandAlt,
      farCompress,
      farCompressAlt,
      farCog,
      farHomeAlt,
      farSignOut,
      farLock,
      farUnlock,
      farRedo,
      farArrowRight,
      farCopy,
      farCalendar,
      farUser,
      farGraduationCap,
      farSackDollar,
      farClock,
      farSeedling,
      farEnvelope,
      farCheckCircle,
      farTimesCircle,
      farSearch,
      farCheck,
      farSignInAlt,
      farSignOutAlt,
      farKey,
      farFolder,
      farPlus,
      farTrashAlt,
      farCommentAlt,
      farBell,
      farComment,
      farBuilding,
      farChartLine
    );

    // solid icons
    this.library.addIcons(
      fasBookmark,
      fasSmile,
      fasMeh,
      fasFrown,
      fasInfoCircle,
      fasCheckCircle,
      fasTimesCircle,
      fasCircle,
      fasCommentAltLines,
      fasChevronRight,
      fasChevronLeft,
      fasArrowRight,
      fasArrowLeft,
      fasLock,
      fasLockOpen,
      fasPencil,
      fasTrash,
      fasBars,
      fasUser,
      fasEye,
      fasEyeSlash,
      fasMinusCircle,
      fasExclamationCircle,
      fasCog,
      fasGraduationCap,
      fasQuestion,
      fasBriefcase,
      fasPlusCircle,
      fasPaperPlane,
      fasCommentAltDots,
      fasFolder,
      fasClone,
      fasThumbsUp,
      fasThumbsDown,
      fasUpload,
      fasShieldAlt
    );
  }
}
